import { Separator } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import type { getArticleCategories } from 'libs/server/api/articles'
import { CategoryListItem } from './CategoryListItem'

type ArticleCategories = Awaited<ReturnType<typeof getArticleCategories>>

interface CategoryListProps {
  categories: ArticleCategories
}

export const CategoryList = ({ categories }: CategoryListProps) => {
  const { t } = useTranslation('@mc/next')

  return (
    <div className='container'>
      <h2 className='mc-text-h8 mc-text--uppercase mc-mb-2'>
        {t('articles.categoriesList.title')}
      </h2>

      <Separator />

      <div className='row mc-pt-7 mc-mb-10'>
        {categories.map((category) => (
          <CategoryListItem category={category} key={category.slug} />
        ))}
      </div>
    </div>
  )
}
